module.exports = __webpack_public_path__ + "autopilot-2-full-ccb24496748f132468737f49da9c849a.webp";